/* <item-slider> — Swiper 래퍼.

   ⚠️ customElements.define 은 같은 이름을 두 번 부르면
   NotSupportedError: the name "item-slider" has already been used
   를 던지고, 그 시점부터 이 파일의 나머지가 실행되지 않는다.
   이 파일을 script_tag 로 넣는 섹션이 한 페이지에 둘 이상 올라오면
   (홈: pethroom-banner-slide × N + 홈 히어로) 바로 그 상황이 된다.
   실제로 홈에서 로드당 두 번 콘솔 에러가 찍히고 있었다. 가드로 막는다. */
document.addEventListener('DOMContentLoaded', function () {
  if (customElements.get('item-slider')) return;

  /* 접근성: 움직임 최소화를 요청한 사용자에게는 자동재생을 하지 않는다.
     (Prestige 코어 슬라이드쇼도 같은 규칙을 따른다) */
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define(
    'item-slider',
    class extends HTMLElement {
      constructor() {
        super();
        this.initSwiper();
      }

      initSwiper() {
        const additionalConfig = this.dataset.config ? JSON.parse(this.dataset.config) : {};

        const config = {
          slidesPerView: parseInt(this.dataset.largeView || 3, 10),
          spaceBetween: 30,
          loop: this.dataset.loop !== 'false',
          centeredSlides: this.dataset.centeredSlides !== 'false',
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          }
        };

        if (this.dataset.pagination !== 'false') {
          config.pagination = {
            el: this.querySelector('.swiper-pagination'),
            clickable: true
          };
        }

        if (this.dataset.navigation !== 'false') {
          config.navigation = {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev')
          };
        }

        Object.assign(config, additionalConfig);

        /* pagination.el / navigation.{next,prev}El 이 문자열 셀렉터로 오면
           Swiper 가 문서 전체에서 ".swiper-pagination" 같은 흔한 클래스를 찾는다.
           이 컴포넌트를 쓰는 섹션(히어로, 배너 슬라이더 등)이 한 페이지에 여럿이면
           나중에 초기화된 인스턴스의 페이지네이션이 앞선 인스턴스 것까지 덮어써 버린다 —
           실제로 이 문제로 히어로(3장)의 점이 상품 슬라이더(12장)의 점 개수로 바뀌는
           버그가 있었다. 문자열이면 반드시 이 요소(this) 안에서만 찾도록 강제한다. */
        if (config.pagination && typeof config.pagination.el === 'string') {
          config.pagination.el = this.querySelector(config.pagination.el);
        }
        if (config.navigation) {
          if (typeof config.navigation.nextEl === 'string') {
            config.navigation.nextEl = this.querySelector(config.navigation.nextEl);
          }
          if (typeof config.navigation.prevEl === 'string') {
            config.navigation.prevEl = this.querySelector(config.navigation.prevEl);
          }
        }

        if (reduceMotion) config.autoplay = false;

        const swiper = new Swiper(this.querySelector('.swiper'), config);

        /* 키보드 사용자가 슬라이드 안의 링크로 들어오면 자동재생을 멈춘다.
           Swiper의 pauseOnMouseEnter 는 포인터만 다루고 포커스는 안 다룬다. */
        if (swiper.autoplay && config.autoplay !== false) {
          this.addEventListener('focusin', function () {
            swiper.autoplay.stop();
          });
          this.addEventListener('focusout', function () {
            swiper.autoplay.start();
          });
        }
      }
    }
  );
});
